export default {"src":"/_next/static/media/try2.7c521f25.svg","height":2048,"width":2048,"blurWidth":0,"blurHeight":0};